// extracted by mini-css-extract-plugin
export default {"container":"about_us_container__YiEFz","item":"about_us_item__SUw7q","overlink":"about_us_overlink__kRGsP","container_features":"about_us_container_features__uK12J"};